import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getConsent, loadAnalytics, setConsent, trackPageView, OPEN_SETTINGS_EVENT, type Consent } from "@/lib/cookieConsent";

/** Branded cookie consent banner for the public website. Analytics only loads after Accept. */
export function CookieConsentBanner() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (getConsent() === null) setOpen(true);
    else loadAnalytics();
    const onOpen = () => setOpen(true);
    window.addEventListener(OPEN_SETTINGS_EVENT, onOpen);
    return () => window.removeEventListener(OPEN_SETTINGS_EVENT, onOpen);
  }, []);

  useEffect(() => {
    const t = setTimeout(() => trackPageView(location.pathname + location.search), 300);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  if (!open) return null;
  const choose = (c: Consent) => {
    setConsent(c);
    setOpen(false);
    if (c === "accepted") setTimeout(() => trackPageView(location.pathname + location.search), 300);
  };

  return (
    <div role="dialog" aria-live="polite" aria-label="Cookie consent"
      className="fixed inset-x-3 bottom-3 z-[100] md:inset-x-auto md:right-6 md:bottom-6 md:max-w-[440px] rounded-[20px] border border-ns-plum/15 bg-ns-beige p-5 md:p-6 text-ns-plum shadow-2xl">
      <div className="mb-3 h-1 w-10 rounded-full bg-ns-lime" />
      <p className="text-[18px] font-semibold leading-tight">We value your privacy</p>
      <p className="mt-2 text-[14px] leading-[1.5] text-ns-plum/80">
        We use essential cookies to run this site. With your permission, we'd also like to use Google Analytics cookies to understand how visitors use it. See our <Link to="/cookies" className="underline underline-offset-2">Cookie Policy</Link>.
      </p>
      <div className="mt-4 flex gap-3">
        <button type="button" onClick={() => choose("rejected")}
          className="flex-1 rounded-[36px] border border-ns-plum px-4 py-2 text-[14px] font-medium hover:bg-ns-plum/10">Reject</button>
        <button type="button" onClick={() => choose("accepted")}
          className="flex-1 rounded-[36px] bg-ns-plum px-4 py-2 text-[14px] font-medium text-ns-beige hover:opacity-90">Accept</button>
      </div>
    </div>
  );
}
